import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import SideNav from "../../../../components/dashboard/Sidebar";
import { get_order_detail } from "../../../../redux/actions/orders";
import { useEffect, useState } from "react";
import { IconEdit } from "@tabler/icons-react";
import axios from "axios";
import { setAlert } from "../../../../redux/actions/alert";
function DashboardUserOrderDetail({ get_order_detail, order, setAlert }) {
  const { id } = useParams();

  const [editableStatus, setEditableStatus] = useState("");

  useEffect(() => {
    get_order_detail(id);
  }, [id]);

  useEffect(() => {
    if (order && order.status) {
      setEditableStatus(order.status);
    }
  }, [order]);

  const handleStatusChange = (e) => {
    setEditableStatus(e.target.value);
  };

  const handleSaveStatus = async () => {
    const config = {
      headers: {
        Accept: "application/json",
        Authorization: `JWT ${localStorage.getItem("access")}`,
        "Content-Type": "application/json",
      },
    };

    const body = JSON.stringify({ status: editableStatus });

    try {
      const res = await axios.put(
        `${process.env.REACT_APP_API_URL}/api/orders/order/update/${id}/`,
        body,
        config,
      );

      if (res.status === 200) {
        get_order_detail(id);
        setAlert("Order status updated successfully", "success");
      }
    } catch (err) {
      console.error(err);
      setAlert("Failed to update order status", "error");
    }
  };

  // Lista de opciones de estado
  // en este ejemplo, deshabilitamos "received" y "cancelled"
  const orderStatusOptions = [
    { value: "not_processed", label: "Not Processed" },
    { value: "processed", label: "Processed" },
    { value: "shipped", label: "Shipped" },
    { value: "delivered", label: "Delivered" },
    { value: "cancelled", label: "Cancelled" },
    { value: "received", label: "Received" },
  ];

  if (!order) {
    return (
      <SideNav>
        <div>Loading...</div>
      </SideNav>
    );
  }

  return (
    <SideNav>
      <div className="container mx-auto px-4 sm:px-8">
        <div className="flex justify-between items-center mt-4">
          <h1 className="text-2xl font-semibold text-gray-900">Order Detail</h1>
        </div>

        <div className="p-4 bg-white rounded-md shadow-md">
          {/* Datos generales de la orden */}
          <p>
            <strong>Transaction ID:</strong> {order.transaction_id}
          </p>
          <p>
            <strong>Full Name:</strong> {order.full_name}
          </p>
          <p>
            <strong>Date Issued:</strong>{" "}
            {new Date(order.date_issued).toLocaleString()}
          </p>
          <p>
            <strong>Address:</strong> {order.address_line_1}{" "}
            {order.address_line_2}
          </p>
          <p>
            <strong>City:</strong> {order.city}
          </p>
          <p>
            <strong>State/Province:</strong> {order.state_province_region}
          </p>
          <p>
            <strong>Country:</strong> {order.country_region}
          </p>
          <p>
            <strong>Postal Code:</strong> {order.postal_zip_code}
          </p>
          <p>
            <strong>Telephone:</strong> {order.telephone_number}
          </p>
          <p>
            <strong>Amount:</strong> ${parseFloat(order.amount).toFixed(2)}
          </p>
          {order.shipping_price !== null && (
            <p>
              <strong>Shipping Price:</strong> $
              {parseFloat(order.shipping_price).toFixed(2)}
            </p>
          )}

          {/* Items de la orden */}
          <div className="mt-4">
            <h2 className="font-semibold text-lg">Order Items</h2>
            {order.order_items && order.order_items.length > 0 ? (
              <ul className="list-disc list-inside">
                {order.order_items.map((item) => (
                  <li key={item.id}>
                    {item.name} – {item.count} x $
                    {parseFloat(item.price).toFixed(2)}
                  </li>
                ))}
              </ul>
            ) : (
              <p>No items in this order.</p>
            )}
          </div>

          {/* Status editable (con restricciones) */}
          <div className="mt-4">
            <label className="font-semibold" htmlFor="statusSelect">
              Order Status:
            </label>
            <div className="flex items-center gap-2 mt-2">
              <select
                id="statusSelect"
                className="border border-gray-300 rounded p-1"
                value={editableStatus}
                onChange={handleStatusChange}
              >
                {orderStatusOptions.map((opt) => (
                  <option
                    key={opt.value}
                    value={opt.value}
                    // Deshabilita los que no pueden ser editados
                    disabled={
                      opt.value === "cancelled" || opt.value === "received"
                    }
                  >
                    {opt.label}
                  </option>
                ))}
              </select>

              <button
                onClick={handleSaveStatus}
                className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded flex items-center gap-1"
              >
                <IconEdit size={18} />
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </SideNav>
  );
}

const mapStateToProps = (state) => ({
  order: state.Orders.order,
});

export default connect(mapStateToProps, { get_order_detail, setAlert })(
  DashboardUserOrderDetail,
);
